import { gql } from '@apollo/client';

export const UPDATE_ROLE = gql`
  mutation UpdateRole($input: RoleApiRequestInput!) {
    updateRole(input: $input) {
      success
      message
      messageCode
      data {
        id
      }
    }
  }
`;

export interface UpdateRoleInput {
  id: number;
  name: string;
  description?: string | null;
  packageIds?: number[];
}

export interface UpdateRoleResponse {
  updateRole: {
    success: boolean;
    message: string;
    messageCode?: string | null;
    data?: { id?: number | string | null } | null;
  };
}

export interface UpdateRoleVariables {
  input: UpdateRoleInput;
}
